module.exports = __webpack_public_path__ + "img/place_holder.65df4c11.png";